import type { QueryKey } from "@tanstack/react-query";
import { allTaskVehiclesQueryKey, tasksQueryOptions } from "./reads";

/** What a write changed beyond the read it names. Each fact has rules below. */
export type Fact = "applicant-data" | "task" | "vehicle-preferences";

type Write = { changes?: QueryKey; facts?: readonly Fact[] };

/** The reads a write leaves stale. This is the only place those rules are stated. */
export function staleReadsAfter({ changes, facts = [] }: Write): QueryKey[] {
  const stale: QueryKey[] = changes ? [changes] : [];
  for (const fact of facts) {
    switch (fact) {
      // The backend re-checks Tasks against the Applicant's data on every such write and may
      // close some.
      case "applicant-data":
      // A Task was skipped, reissued, answered or submitted.
      case "task":
        stale.push(tasksQueryOptions.queryKey);
        break;
      // Preferences and budget reorder and filter every Task's vehicle grid; the key
      // prefix-matches all of them.
      case "vehicle-preferences":
        stale.push(allTaskVehiclesQueryKey);
        break;
    }
  }
  const seen = new Set<string>();
  return stale.filter((key) => {
    const id = JSON.stringify(key);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}
